import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import PropTypes from 'prop-types';
// import { fetchBalance } from './fetchBalanceServices';
// import { fetchTransactions } from './fetchCashTransactions';
// import TransactionRow from './components/transactionrow';
// import FormattedCurrencyNumber from '../../../FormattedCurrencyNumber';
import LoadingState from '../common/loading-state/index';
import { getInstrumentedAxiosInstance } from '../../globs/ajax-proxy';
import config from '../../globs/config';
import gaPush from '../../globs/utils/google-analytics';

class Loyalty extends React.Component {
  static propTypes = {
    user: PropTypes.shape({}).isRequired,
  }
  state = {
    isNavHidden: false,
    ajaxloadingState: 'None',
    isDataLoading: true,
    customerID: '',
    loyaltyData: {}
  }
  componentDidMount() {
    const salesOfficerId = this.props.user.id;
    console.log('wallah ',salesOfficerId);
    const path_ = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${this.props.match.params.customerId}/get_loyalty_points`;
    getInstrumentedAxiosInstance().get(path_)
    .then((res) => {
      console.log('loyality pts',res)
      this.setState({
        loyaltyData: res.data,
        isDataLoading: false,
      });
    })
    .catch((err) => console.log(err))
  }


  render() {
    const { props, state } = this;
    const LOYALTYDATA = props.user.settings_data.LOYALTY_POINTS_DATA;
    console.log('xxxx-xxxxxxx--', state);
    let isDataLoading;
    const classes = {
      view: classNames('lr-state-view lr-main-view', {
        'is-in-transition': !state.hasTransitioned,
      }),
      header: classNames('lr-main-view__header', {
        'is-nav-hidden': isDataLoading || state.isNavHidden,
      }),
    };
    return (
      <div className={classes.view} >
        <div className={classes.header}>
          <button
            type="button"
            onClick={() => props.history.goBack()}
            className="lr-main-view__header-title versementheader"
          >
            <i className="icon-back" />
            <div>Loyalty</div>
          </button>
          {state.isDataLoading &&
            <div>
              <LoadingState />
              <div className="loadingContainer" />
            </div>
          }
        </div>
        <div className="lr-statment lr-main-view__body">
          <div className="loyalty-page">
            <div className="loyalty-point">
              <p>
                {LOYALTYDATA?.title?.hasOwnProperty('en-KE') ? (
                    <div>
                      {LOYALTYDATA?.title['en-KE']}
                    </div>
                  ) : null}
              </p>
              <p>{Number(state.loyaltyData.points).toFixed(2)}</p>
            </div>
            <img src={LOYALTYDATA?.images[0]} alt="LoyaltyImg" /> 
          </div>
        </div>
      </div>
    );
  }
}


export default Loyalty;
